/**
 * @deprecated 舊版付款方式 目前fortune-panel上仍使用 (後端內部轉換)
 */
export enum PaymentMethod {
  /**
   * 現場付款
   */
  OFFLINE_PAYMENT = 'offline_payment',
  OFFLINE_CASH = 'offline_cash',
  OFFLINE_CREDIT_CARD = 'offline_credit_card',
  OFFLINE_JKO_PAY = 'offline_jko_pay',
  OFFLINE_LINE_PAY = 'offline_line_pay',

  CHECKOUTPAY_DIRECT = 'checkoutpay_direct',
  CHECKOUTPAY_APPLE_PAY = 'checkoutpay_apple_pay',

  TAPPAY_DIRECT = 'tappay_direct',
  TAPPAY_LINE_PAY = 'tappay_line_pay',
  TAPPAY_JKO_PAY = 'tappay_jko_pay',
  TAPPAY_APPLE_PAY = 'tappay_apple_pay',

  COD = 'cod',
  BACS = 'bacs',
  /**  指定付款 不開發票 */
  CHEQUE = 'cheque',

  ECPAY_ATM = 'ecpay_atm',
}

export enum Currency {
  TWD = 'TWD',
  HKD = 'HKD',
  SGD = 'SGD',
  MYR = 'MYR',
  USD = 'USD',
}

export const CampaignPaymentOptionTypes = {
  /** 信用卡一次付清 */
  CREDIT_CARD_ONCE: 'credit_card_once',
  /** 信用卡分期付款 */
  CREDIT_CARD_INSTALLMENT: 'credit_card_installment',
  /** 街口支付 */
  JKO_PAY: 'jko_pay',
  /** Line Pay */
  LINE_PAY: 'line_pay',
  /** Apple Pay */
  APPLE_PAY: 'apple_pay',
  /** 貨到付款 */
  CASH_ON_DELIVERY: 'cash_on_delivery',
  /** 超商代碼 */
  CVS: 'cvs',
  /** ATM轉帳 */
  ATM: 'atm',
  /** 指定付款 */
  ASSIGNED_PAYMENT: 'assigned_payment',
  /** 指定付款（開發票） */
  ASSIGNED_PAYMENT_INVOICE: 'assigned_payment_invoice',
  /** 線下付款 */
  OFFLINE_PAYMENT: 'offline_payment',
  /** Alipay */
  ALIPAY_HK: 'alipay_hk',
  /** WeChat Pay */
  WECHAT_PAY: 'wechat_pay',
  /** PayMe */
  PAYME: 'payme',
} as const

/**
 * 將 TapPay 回傳的卡片類型轉換為信用卡組織類型
 */
export const CARD_TYPE_TO_ORGANIZATION = {
  'VISA': 'visa',
  'MASTERCARD': 'master',
  'JCB': 'jcb',
  'AMEX': 'american express',
  'AMERICAN EXPRESS': 'american express',
} as const
